module.exports = __webpack_public_path__ + "fd5a608a/img/default_profile.e274a23e.png";